import React from "react";  

const FASTDashboard = () => <div>FAST Dashboard</div>;

export default FASTDashboard;